import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext<any>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any>(null);
  const [kid, setKid] = useState<any>(() => JSON.parse(localStorage.getItem("cast_kid") || "null"));

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("cast_kid");
    setKid(null);
    setUser(false);
  };
  const enterKids = (c: any) => { localStorage.setItem("cast_kid", JSON.stringify(c)); setKid(c); };
  const exitKids = () => { localStorage.removeItem("cast_kid"); setKid(null); };

  return <Ctx.Provider value={{ user, setUser, refresh, logout, kid, enterKids, exitKids }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
